import { useState, useEffect } from 'react'
import styles from '../../../pages/LeadCapture/QualifierManager/QualifierManager.module.css'
// Font Awesome assets
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faSquareXmark } from '@fortawesome/free-solid-svg-icons'
// ------ Image Elements ------ //
const bars = <FontAwesomeIcon icon={faBars} style={{ color: 'blue', width: '20px', height: '20px' }} />
const squareXmark = <FontAwesomeIcon icon={faSquareXmark} style={{ color: 'red', width: '20px', height: '20px' }} />

const QualifierSelection = ({ qualifierEntry, removeSelection, submitEdit, index, provided, innerRef }) => {
    const [newSelection, setNewSelection] = useState(null)
    const handleChange = (e) => {
        setNewSelection(e.target.value);
        submitEdit(e, e.target.value);
    }
    useEffect(() => {
        setNewSelection(qualifierEntry);
    }, [])
    return (
        <>
            <tr key={qualifierEntry + index}
                {...provided.dragHandleProps}
                {...provided.draggableProps}
                ref={innerRef} className={styles.trQualifiers}>
                <td className={styles.tdQualifiers}>
                    <i>{bars}</i>
                </td>
                <td className={styles.tdQualifiers}> <textarea
                    id={'edit' + index}
                    autoComplete="off"
                    value={newSelection}
                    name="newSelection"
                    rows="2"
                    cols="35"
                    onChange={handleChange}
                /></td>

                <td className={styles.tdQualifiers}>
  
                    <button onClick={e => removeSelection(e)} title="Remove selection option." id={'remove' + index}>
                        <i>{squareXmark}</i>
                    </button>
                </td>
            </tr>
        </>
    );
}

export default QualifierSelection;